/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiErrorDTO, ApiErrorMessageDTO } from '@api/models';

export class ApiErrorDecoder {
  protected error: ApiErrorMessageDTO;

  protected defaultMessage: string;

  constructor(error: ApiErrorDTO, defaultMessage: string) {
    this.error = this.decodeError(error);
    this.defaultMessage = defaultMessage;
  }

  /**
   * restituisce il messaggio di errore
   */
  getMessage(): string {
    const message = this.error.message;

    if (
      typeof message === 'string' &&
      message.toUpperCase() !== 'GENERIC_ERROR'
    ) {
      return message;
    } else if (typeof this.defaultMessage === 'string') {
      return this.defaultMessage;
    } else {
      return 'Error';
    }
  }

  /**
   * restituisce il codice dell'errore
   */
  getCode(): string {
    return this.error.code || '';
  }

  /**
   * restituisce l'id parziale di errore
   */
  getPartialUuid(): string {
    const uuid = this.getUuid();

    if (typeof uuid === 'string' && uuid.indexOf('-') > -1) {
      return uuid.substring(0, uuid.indexOf('-'));
    } else {
      return uuid;
    }
  }

  /**
   * restituisce l'id dell'errore
   */
  getUuid(): string {
    return this.error.uuid || '0';
  }

  /**
   * decodifica l'errore
   */
  protected decodeError(error: any): ApiErrorMessageDTO {
    if (typeof error === 'string') {
      try {
        error = JSON.parse(error);
      } catch (_) {
        error = {};
      }
    }

    if (error && error.messages instanceof Array && error.messages[0]) {
      error = error.messages[0];
    } else {
      error = {};
    }

    return {
      category: null,
      code: error.code || null,
      message: error.message || null,
      renderingMode: null,
      severity: error.severity || null,
      title: error.title || null,
      uuid: error.uuid || null
    };
  }
}
